/**
 * Cross-app route map for the Bifrost Nuxt 2 → Nuxt 4 migration.
 *
 * Each entry maps a URL path pattern to the app that owns it.
 * Patterns are matched top-to-bottom; first match wins.
 *
 * Supported pattern syntax:
 *   - Exact path: '/login'
 *   - Prefix (trailing wildcard): '/settings/**' — matches '/settings' and all sub-paths
 */

export type AppTarget = "legacy" | "web";

export interface RouteEntry {
  /** URL path prefix or exact path */
  pattern: string;
  /** Which app handles this route */
  app: AppTarget;
}

/**
 * Ordered route map. First match wins.
 * Add entries here as routes are migrated to the web app.
 *
 * Example:
 *   { pattern: '/dashboard', app: 'web' },
 *   { pattern: '/settings/**', app: 'web' },
 */
export const routeMap: RouteEntry[] = [];

/** Default app for routes not matched by any entry. */
export const defaultApp: AppTarget = "legacy";
